import {
  useEffect,
} from "react";

import { createSequentialPoller } from "../utils/sequentialPoller.mjs";

import {
  getPendingLocalWithdrawals,
} from "../storage/offlineDatabase";
import {
  processSyncQueue,
} from "../services/syncService";
import { flushPendingPaperHandovers } from "../services/paperHandoverService";
import {
  registerMaterialentnahmeBackgroundSync,
  updateMaterialentnahmeAppBadge,
} from "../services/serviceWorkerService";


const SYNC_INTERVAL_MS =
  10_000;


export function useSyncQueue() {
  useEffect(() => {
    const refreshBackgroundState = async () => {
      const pending = await getPendingLocalWithdrawals().catch(() => []);
      await updateMaterialentnahmeAppBadge(pending.length);
      if (pending.some((record) => (record.sync_attempt_count ?? 0) < 9)) {
        await registerMaterialentnahmeBackgroundSync();
      }
    };

    const poller = createSequentialPoller({
      intervalMs: SYNC_INTERVAL_MS,
      initialDelayMs: 750,
      pauseWhenHidden: true,
      request: async () => {
        if (navigator.onLine) {
          await processSyncQueue();
          // Ausdruck-&-Übergabe nutzt denselben bestehenden Vordergrund-Poller:
          // kein eigener Timer, kein eigener Worker. Dadurch werden offline
          // bestätigte Übergaben auch dann nachgezogen, wenn das Gerät selbst
          // nie offline war und deshalb kein Browser-`online`-Event entsteht.
          await flushPendingPaperHandovers();
        }
        await refreshBackgroundState();
        return null;
      },
    });

    const triggerSync = () => poller.trigger();
    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") poller.trigger();
      else void refreshBackgroundState();
    };
    const onStatusRefresh = () => void refreshBackgroundState();

    poller.start();
    window.addEventListener("online", triggerSync);
    window.addEventListener("pageshow", triggerSync);
    window.addEventListener("focus", triggerSync);
    window.addEventListener("materialentnahme:status-refresh", onStatusRefresh);
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      poller.stop();
      window.removeEventListener("online", triggerSync);
      window.removeEventListener("pageshow", triggerSync);
      window.removeEventListener("focus", triggerSync);
      window.removeEventListener("materialentnahme:status-refresh", onStatusRefresh);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);
}
